export const REWARDS_EXCHANGES = ['bingx', 'bybit', 'bitget'] as const
export type RewardsExchange = (typeof REWARDS_EXCHANGES)[number]

export const REWARDS_LINK_STATUSES = ['awaiting', 'linked', 'not_linked', 'syncing', 'error'] as const
export type RewardsLinkStatus = (typeof REWARDS_LINK_STATUSES)[number]

export type RewardsAccountExchangeLink = {
  id: string
  account_id: string
  exchange: RewardsExchange
  exchange_user_id: string
  status: RewardsLinkStatus
  linked_at: string | null
  last_sync_at: string | null
  last_error: string | null
  created_at: string
  updated_at: string
}

export type RewardsCycle = {
  id: string
  account_id: string
  stripe_subscription_id: string | null
  plan_id: string | null
  period_start: string
  period_end: string
  status: 'open' | 'closed'
  closed_at: string | null
  invoice_id: string | null
  volume_usdt_total: number
  commission_estimated_usdt_total: number
  commission_confirmed_usdt_total: number
  discount_amount_cents: number
  discount_currency: string
  created_at: string
  updated_at: string
}

export type RewardsCycleExchangeMetric = {
  cycle_id: string
  exchange: RewardsExchange
  volume_usdt: number
  commission_estimated_usdt: number
  commission_confirmed_usdt: number
  last_synced_at: string | null
  source: string | null
  updated_by: string | null
  created_at: string
  updated_at: string
}

export type RewardsTrialAttempt = {
  id: string
  user_id: string
  account_id: string
  status: 'active' | 'approved' | 'failed' | 'canceled'
  selected_plan_id: string | null
  stripe_customer_id: string | null
  stripe_subscription_id: string | null
  started_at: string
  check_deadline_at: string
  trial_end_at: string | null
  min_volume_usdt: number
  volume_usdt_at_deadline: number
  passed: boolean | null
  evaluated_at: string | null
  fail_reason: string | null
  override_volume_usdt: number | null
  override_passed: boolean | null
  override_note: string | null
  overridden_by: string | null
  overridden_at: string | null
  created_at: string
  updated_at: string
}

